module.exports = __webpack_public_path__ + "static/media/share_add_person.28d787e2.svg";